
import React, {ReactElement} from 'react';
import FeatureInfo from '../../content/FeatureInfo';
import {getRSVPsToEvent, eventRsvpList} from '../calendar/types/eventModel';

import CollapsibleContent from '../../content/colPanels/CollapsibleContent';
import CollapsibleHostControl from '../../content/colPanels/standard/CollapsibleHostControl';
import CollapsibleLodging from '../../content/colPanels/plus/CollapsibleLodging';
import CollapsibleMarkdown from '../../content/colPanels/CollapsibleMarkdown';
import CollapsibleSchedule, {CalSessionC} from '../../content/colPanels/standard/CollapsibleSchedule';
import CollapsibleStandardRSVP from '../../content/colPanels/standard/CollapsibleStandardRSVP';

import CollapsableVenue from '../../content/CollapsableVenue';



import { useNavigate } from "react-router-dom";
import {EventFullInfo} from '../../../models/event';
import {ETypeNum, eTypeString} from "../../../models/event/EType";
import {getSpecificEvent} from '../../../utils/event';
import { getUserDetails, getUserDetailsByName, UserDetails } from "../../../models/user/userInfo";
import { getVenueDetails, VenueDetails } from '../venues/venueModels';
import { useParams } from 'react-router-dom';
import { toggleUserSessionStatus } from '../../../functions/Sessions';
import { getGsessionsForEvent } from '../../../functions/Sessions';
import { validatePermission } from '../../../utils/index';

import {fetchEventAttendees} from '../../../utils';
import CollapsibleRegistration from '../../content/colPanels/plus/CollapsibleRegistration';
import { RegistrationItem } from '../../../models/registrations/registrations';
import moment from 'moment-timezone';
import { getItemsForEvent } from '../../../functions/Items';


interface eventPageProps
{
    loggedInUser ?: number,
    authToken ?: string
}





const EventPage = (props: eventPageProps) => 
{
    const [event, setEvent] = React.useState<EventFullInfo | undefined>(undefined);
    const [owner, setOwner] = React.useState<string| undefined>(undefined);
    const [user, setUser] = React.useState<UserDetails | undefined>(undefined);
    const [venue, setVenue] = React.useState<VenueDetails | undefined>(undefined);
    const [registerList, setRegisterList] = React.useState<eventRsvpList | undefined>(undefined);
    const [seshCList, setSeshCList] = React.useState<CalSessionC[] | undefined>(undefined);
    const [refresh, setRefresh] = React.useState<Boolean>(false);
    const [editPermission, setEditPermission] = React.useState<Boolean>(false);
    const [eventRSVPArray, setEventRSVPArray] = React.useState<string[]>(() => []);
    const [itemList, setItemList] = React.useState<RegistrationItem[]>([]);
//    const [eventRSVPSeeded, setEventRSVPSeeded] = React.useState<Boolean>(false);
//    const [eventRSVPString, setEventRSVPString] = React.useState<string>("...");

    const navigate = useNavigate();

    const params = useParams();

    const eventId: number | undefined = params.eventId ? parseInt(params.eventId) : undefined;
    
    const defaultLocale = 'America/New_York'; // TODO: replace use of hard-coded locale with locale fetched from user profile


    function getEventRSVPArray(): string[]
    {
        if(event !== undefined)
        {
            fetchEventAttendees(event.id).then((attendeeResponse) =>
                {
                    if(attendeeResponse !== undefined)
                    {
                        setEventRSVPArray(attendeeResponse);
                        return(attendeeResponse);
                    }
                    else
                    {
                        console.log("[EventPage:loadEventRSVPArray] ERROR: attendeeResponse is undefined");
                    }
                });
        }
        else
        {
            console.log("[EventPage:loadEventRSVPArray] ERROR: event is undefined");
        }

        return([]);
    }


    React.useEffect(() => 
    {
        //TODO: Make this trigger a single refresh in a less hacky way.
        if(refresh) 
        {
            setRefresh(false);
            return;
        }
        

        if(eventId === undefined) 
        {
            setEvent(undefined);
            setOwner(undefined);
            setVenue(undefined);
            setRegisterList(undefined);
        }
        else 
        {
            getSpecificEvent(eventId).then((res) => 
            {

                res && setEvent(res);
                console.log('EVENT');
                console.log(res);
                res && setOwner(res.owner);

                res && getVenueDetails(res.venue).then((ven) => 
                {
                    setVenue(ven);
                });

                getRSVPsToEvent(eventId).then((rsvp) => 
                {
                    rsvp && setRegisterList(rsvp);
                });

                

            });

            getGsessionsForEvent(eventId).then((res) => 
            {
                setSeshCList(res);
            });
        }
    }, [eventId, refresh]);





    React.useEffect(() =>
    {
        if(props.loggedInUser === undefined) 
        {
            setUser(undefined);

        }
        else 
        {
            getUserDetails(props.loggedInUser).then((res) => 
            {
                res && setUser(res);
            });
        }
    },[props.loggedInUser]);





    React.useEffect(() => 
    {
        if(eventId !== undefined) 
        {
            const eventPageFetchEventAttendees = async() =>{
                const aResult = await fetchEventAttendees(eventId);

                if(aResult !==  undefined)
                {
                    setEventRSVPArray(aResult);
                }
                else
                {
                    console.log("[EventPage:useEffect] ERROR: aResult is undefined");
                }
            };

            eventPageFetchEventAttendees();
        }

        
        /*
        if(eventId === undefined) 
        {
            setRegisterList(undefined);

        }
        else 
        {
            getRSVPsToEvent(eventId).then((rsvp) => 
            {
                rsvp && setRegisterList(rsvp);
            });
        }*/
    }, [eventId]);

    React.useEffect(() =>
    {
        if(eventId != undefined)
        {
            getItemsForEvent(eventId).then((res) =>
            {
                console.log(res);
                setItemList(res);
            })
        }
    },[eventId])





    React.useEffect(() =>
    {
        if (props.authToken === undefined) {
            setEditPermission(false)
        } else {
            validatePermission('CanEditAllEvents', props.authToken)
            .then((res) => {
                setEditPermission(res)
            })
        }
    }, [props.authToken])





    if (!event || !owner || !venue || !registerList || !seshCList)
    {
        return (<div><b>Loading Event...</b></div>)
    }


    if(event.name !== "Titan Buster" && event.name !== "Gamacea 2023" && event.name !== "Gamacea 2024")
    {
        //const blah: string[] = getEventRSVPArray();

        //console.log("[EventPage:main-if] blah.length = " + blah.length.toString());
        console.log("[EventPage:main-if] eventRSVPArray.length = " + eventRSVPArray.length.toString());

        for(let i = 0; i < eventRSVPArray.length; i++)
        {
            console.log("[EventPage:main-if] eventRSVPArray[" + i + "] = " + eventRSVPArray[i]);
        }

        const eventType = 
        {
            id: event.eType,
            name: eTypeString[event.eType]
        };

        const onRsvpToggle = (() =>
        {
            eventId && getRSVPsToEvent(eventId).then((rsvp) =>
            {
                rsvp && setRegisterList(rsvp);
            });
        });

        const onFullScheduleClick = () => 
        {
            navigate('/events/eventpage/calendar/' + eventId);
        }

        const onSignUpChange = (sesh: number, signUpStatus: boolean) => 
        {
            return toggleUserSessionStatus({user: props.loggedInUser, authToken: props.authToken}, sesh ,signUpStatus).then((result) => 
            {
                result && setRefresh(true);
                return result;
            });
        }

        const userIsOwner = user?.user_name === event.owner;



        

        // generate panels used by all event types

        let eventPageOut: ReactElement = (<div className="event-grid">Unexpected event page rendering error</div>);

        let eventHeaderBase: ReactElement = (<FeatureInfo startTime={event.start_DateTime} endTime={event.end_DateTime} name={event.name} owner={owner} timeZone={defaultLocale}/>);

        let eventMainBase: ReactElement = (
                                            <div className="event-main-base">
                                                <CollapsibleMarkdown title={"Details"} startingIsCollapsed={false} content={event.info} />
                                                <CollapsibleSchedule onSignUpChange={onSignUpChange} authToken={props.authToken} evnt={event} sessionCList={seshCList} startingIsCollapsed={false} user={user} registrantList={registerList.data} onFullSchedule={onFullScheduleClick}/>
                                                {event.main_Map_Image && <CollapsibleContent title={"Event Map"} startingIsCollapsed={true}>
                                                    <img src={"https://tabletopgamersalliance.com/i/ev/" +  event.id + "/" + event.main_Map_Image} />
                                                </CollapsibleContent>}
                                            </div>
                                        );
        
        let eventSideBarBase: ReactElement = (
                                                <CollapsableVenue user={user} registrantList={registerList.data} venue={venue} isHidden={false} title={"Venue Info"} startingIsCollapsed={false} />
                                            );

        let eventHostControl: ReactElement = (
                                                <div>
                                                    {user && props.authToken && (userIsOwner || editPermission) && <CollapsibleHostControl title={'Event Host Panel'} startingIsCollapsed={true} loggedInUser={user.id} authToken={props.authToken} event={event} />}
                                                </div>
                                            );

        let standardRSVP: ReactElement = (
                                            <CollapsibleStandardRSVP startingIsCollapsed={false} registrantList={registerList.data} eventInfo={event} eventType={eventType} user={user} authToken={props.authToken} onRsvpToggle={onRsvpToggle} />
                                        );
                                        
        let devStat: ReactElement = (<p></p>); 

        if(process.env.REACT_APP_MODE !== "production")
        {
           devStat = (<div className="dev-stat">{process.env.REACT_APP_MODE !== "production" && <p>event type: {eTypeString[event.eType]}</p> }</div>);
        }
        




        // generate event-type specific panels
        switch (event.eType)
        {
            case ETypeNum.Premiere:
                let premiereHeader: ReactElement = (<div className="event-header">{eventHeaderBase} <p>.</p></div>);

                eventPageOut = (
                                <div className="event-grid">
                                    {premiereHeader}

                                    <div className="event-main">
                                        {eventMainBase}
                                    </div>

                                    <div className="event-side">
                                        <div className="event-side-base">
                                            <CollapsibleRegistration
                                                startingIsCollapsed = {false}
                                                registeredContent = {"Registered"}
                                                unRegisteredContent = {"Not Registered"}
                                                registrationItems = {itemList}
                                                registrantList={registerList.data}
                                                eventName = {event.name}
                                                eventId = {event.id}
                                            />
                                            {eventSideBarBase}
                                            
                                            {event.lodging_Info && <CollapsibleLodging startingIsCollapsed={false} lodgingContent={event.lodging_Info} />}

                                            {eventHostControl}
                                        </div>
                                    </div>

                                    {devStat}
                                </div>
                            );
                break;
            case ETypeNum.Standard:
                eventPageOut = (
                                <div className="event-grid">
                                    {eventHeaderBase}

                                    <div className="event-main">
                                        {standardRSVP}
                                        {eventMainBase}
                                    </div>

                                    <div className="event-side">
                                        <div className="event-side-base">
                                            {eventSideBarBase}
                                            {eventHostControl}
                                        </div>
                                    </div>

                                    {devStat}
                                </div>
                            );
                break;
            default:
                eventPageOut = (<div className="event-grid">Encountered an event of unknown type</div>);
        }

        return(eventPageOut);
    }
    else if (event.name === "Titan Buster")
    {

        const registeredBlob = <h4>You're Registered for Titan Buster!</h4>

        const unregisteredBlob = <h4>This is an Invite-Only Event.</h4>

        const eventType = 
        {
            id: 1,
            name: "Premium"
        };

        const registeredOnClick = () => 
        {
            navigate("/TitanBuster/temp_schedule")
        }

        const unregisteredOnClick = () => 
        {
            navigate("/Titanbuster/validation")
        }

        const registeredSection = <div>{registeredBlob}<button onClick={() => registeredOnClick()}>View Event Calendar</button></div>

        const unregisteredSection = <div>{unregisteredBlob}<button onClick={() => unregisteredOnClick()}>Validate Registration</button></div>

        return(
            <div>
                <img className="titan-logo" src="https://www.tabletopgamersalliance.com/i/TitanBuster/2024/TitanBuster_splash.png" alt="" />

                <FeatureInfo startTime={event.start_DateTime} endTime={event.end_DateTime} name={event.name} owner={owner}/>

                <div className="event-grid">

                    <div className="event-main">
                        <CollapsibleStandardRSVP startingIsCollapsed={false} registrantList={registerList.data} eventInfo={event} eventType={eventType} user={user} authToken={props.authToken} registeredContent={registeredSection} unregisteredContent={unregisteredSection} collapsableTitle={"Registration"} registrationsName={"Registrations"} registrationsVerb={"Register"}/>
                        <CollapsibleMarkdown title={"Details"} startingIsCollapsed={false} content={event.info} />
                    </div>

                    <div className="event-side">
                        <CollapsableVenue user={user} registrantList={registerList.data} venue={venue} isHidden={true} title={"Venue Info"} startingIsCollapsed={false} />
                    </div>

                </div>
            </div>
        );

    }
    else if (event.name === "Gamacea 2024") 
    {
        navigate("/2024/gamacea");
        return(<div><b>Loading Event...</b></div>);

    }
    else if (event.name === "Gamacea 2023") 
    {
        navigate("/2023/gamacea");
        return(<div><b>Loading Event...</b></div>);

    }
    else
    {
        return(<div>Error: Unable to render event.</div>);
    }

    

}

export default EventPage;